import {ActionButton, Actions} from './Actions'
import {ErrorBanner} from './ErrorBanner'
import {Footer, FooterButton} from './Footer'
import {Label} from './Label'
import _MarkdownEditor from './MarkdownEditor'
import {MarkdownEditorContext} from './MarkdownEditorContext'
import {DefaultToolbarButtons, Toolbar} from './Toolbar'
import {ToolbarButton} from './ToolbarButton'

export type {MarkdownEditorHandle} from './MarkdownEditor'
export type {MarkdownViewMode as ViewMode} from '@github-ui/markdown-editor-view-switch/types'

export const MarkdownEditor = Object.assign(_MarkdownEditor, {
  /** REQUIRED: An accessible label for the editor. */
  Label,
  /**
   * An optional custom toolbar. The toolbar should contain `ToolbarButton`s before
   * and/or after a `DefaultToolbarButtons` instance. To create groups of buttons, wrap
   * them in an unstyled `Box`.
   */
  Toolbar,
  /**
   * A custom toolbar button. This takes `IconButton` props. Every toolbar button should
   * have an `aria-label` defined.
   */
  ToolbarButton,
  /**
   * The full set of default toolbar buttons. This is all the basic formatting tools in a
   * standardized order.
   */
  DefaultToolbarButtons,
  /** An optional custom footer to show below the editor. */
  Footer,
  /** A button to show at the start of the editor footer, before the `ActionButton`s. */
  FooterButton,
  /**
   * Optionally define a set of custom buttons to show in the footer. Often if you
   * are defining custom buttons you should also wrap the editor in a `<form>`. This
   * component should only contain `ActionButton`s.
   */
  Actions,
  /** A button to show at the end of the editor footer, after any `FooterButton`s. */
  ActionButton,
  /**
   * A pre-styled error banner for use with the `banner` prop. Wraps content in
   * AriaAlert for accessibility announcements.
   */
  ErrorBanner,
  /**
   * Holds state of the editor.
   */
  MarkdownEditorContext,
})
export type {MarkdownEditorProps} from './MarkdownEditor'
export type {SavedReply} from './SavedReplies'
export type {Emoji} from './suggestions/use-emoji-suggestions'
export type {Mentionable} from './suggestions/use-mention-suggestions'
export type {Reference} from './suggestions/use-reference-suggestions'
export type {FileType, FileUploadResult} from './UseFileHandling'
export {useFileHandling} from './UseFileHandling'
